import React, { useEffect, useRef } from "react";

function TAMCell({ cell, toneIndex }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;

    if (!canvas) {
      return;
    }

    canvas.width = cell.size;

    canvas.height = cell.size;

    const context = canvas.getContext("2d");

    context.clearRect(0, 0, cell.size, cell.size);

    context.drawImage(cell.canvas, 0, 0);
  }, [cell]);

  return (
    <div className="tam-hierarchy-cell">
      <canvas ref={canvasRef} />

      <div className="tam-hierarchy-cell-info">
        <strong>T{toneIndex + 1}</strong>

        <span>{cell.darkness.toFixed(2)}</span>
      </div>
    </div>
  );
}

export default function TAMAtlas({ tam }) {
  return (
    <div className="tam-atlas">
      <div className="tam-atlas-header">
        <strong>TONAL ART MAP</strong>

        <span>{tam.strokeCount} STROKES</span>
      </div>

      <div className="tam-hierarchy">
        <div className="tam-hierarchy-corner">SCALE / TONE</div>

        {tam.tones.map((_, toneIndex) => (
          <div key={`tone-${toneIndex}`} className="tam-hierarchy-column-label">
            T{toneIndex + 1}
          </div>
        ))}

        {tam.hierarchy.map((row, scaleIndex) => (
          <React.Fragment key={`scale-${scaleIndex}`}>
            <div className="tam-hierarchy-row-label">
              <strong>{row[0].size}px</strong>

              <span>L{scaleIndex}</span>
            </div>

            {row.map((cell, toneIndex) => (
              <TAMCell
                key={`${scaleIndex}-${toneIndex}`}
                cell={cell}
                toneIndex={toneIndex}
              />
            ))}
          </React.Fragment>
        ))}
      </div>

      <div className="tam-direction">
        <span>LIGHT</span>

        <span>→</span>

        <span>DARK</span>
      </div>
    </div>
  );
}
